var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOmg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.36 18.359-2.586-7.133h-2.2v9.33h1.586v-6.573l2.4 6.572h1.56l2.397-6.572v6.572h1.626v-9.33h-2.198l-2.584 7.133zm-10.683-7.36C2.813 11 1 13.16 1 15.9c0 2.736 1.813 4.89 4.677 4.89s4.68-2.138 4.68-4.892c0-2.754-1.812-4.898-4.681-4.898zm0 8.132c-1.826 0-2.918-1.374-2.918-3.227 0-1.855 1.091-3.237 2.917-3.237 1.825 0 2.921 1.386 2.921 3.23s-1.093 3.234-2.921 3.234zm20.979-1.97h2.678c-.158 1.36-1.147 2-2.413 2-1.812 0-2.823-1.335-2.823-3.255 0-1.8.89-3.278 2.785-3.278 1.239 0 2.24.631 2.347 1.693H31c-.24-2.133-1.866-3.32-4.064-3.32-3.12 0-4.574 2.4-4.574 4.958 0 2.749 1.682 4.827 4.294 4.827 1.53 0 2.387-.708 2.731-1.307v1.066H31v-4.989h-4.344v1.605z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmg);
export default __webpack_public_path__ + "static/media/OMG.5bebb6d0cfa5702c8d26833b9fa75282.svg";
export { ForwardRef as ReactComponent };